export default {
    Order: {},
    Orders: [],
    TotalInfo: {
        count: 0,
        limit: 20,
        page: 1,
        rows: []
    },
}